import { z } from 'zod';

export const EMAIL_HINT = 'Enter a full address, like name@company.com.';

export const signInEmailSchema = z.object({
  email: z
    .string()
    .trim()
    .pipe(z.email({ error: EMAIL_HINT })),
});

export type SignInEmailValues = z.infer<typeof signInEmailSchema>;

export const SIGN_IN_EMAIL_DEFAULTS: SignInEmailValues = { email: '' };
